interface Props {
    className?: string;
}

export function ChevronUpIcon({ className }: Props) {
    return (
        <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.3911 14.752L10.5044 5.25781C10.2544 4.91406 9.7427 4.91406 9.49465 5.25781L2.60598 14.752C2.58903 14.7753 2.57887 14.8029 2.57664 14.8317C2.57441 14.8604 2.58018 14.8893 2.59333 14.9149C2.60648 14.9406 2.62648 14.9622 2.65112 14.9772C2.67576 14.9922 2.70408 15.0001 2.73293 15H4.19778C4.29739 15 4.39114 14.9512 4.44973 14.8711L9.99856 7.22266L15.5474 14.8711C15.606 14.9512 15.6997 15 15.7993 15H17.2642C17.3911 15 17.4654 14.8555 17.3911 14.752Z"
                fill="currentColor"
            />
        </svg>
    );
}
